import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
  .plans-page { font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; -webkit-font-smoothing: antialiased; }
  .plans-page * { box-sizing: border-box; }

  .plans-hero {
    position: relative;
    padding: 80px 24px 60px;
    text-align: center;
    overflow: hidden;
    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563eb 100%);
  }
  .plans-hero::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: radial-gradient(ellipse at 30% 50%, rgba(255,255,255,0.08) 0%, transparent 70%);
    pointer-events: none;
  }
  .plans-hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.12);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255,255,255,0.15);
    border-radius: 100px;
    padding: 6px 16px;
    font-size: 12px;
    font-weight: 600;
    color: rgba(255,255,255,0.9);
    letter-spacing: 0.05em;
    text-transform: uppercase;
    margin-bottom: 20px;
  }
  .plans-hero h1 {
    margin: 0 0 12px;
    font-size: 44px;
    font-weight: 900;
    color: #fff;
    letter-spacing: -0.02em;
    line-height: 1.1;
  }
  .plans-hero-sub {
    margin: 0 auto;
    font-size: 17px;
    color: rgba(255,255,255,0.75);
    max-width: 600px;
    line-height: 1.6;
  }

  .plans-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 32px;
  }
  .plans-toggle-label {
    font-size: 14px;
    font-weight: 600;
    color: rgba(255,255,255,0.7);
  }
  .plans-toggle-label.active { color: #fff; }
  .plans-toggle-switch {
    width: 52px;
    height: 28px;
    border-radius: 14px;
    background: rgba(255,255,255,0.2);
    border: 2px solid rgba(255,255,255,0.3);
    cursor: pointer;
    position: relative;
    transition: all 0.3s;
  }
  .plans-toggle-switch.on { background: #2563eb; border-color: #2563eb; }
  .plans-toggle-switch::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    top: 2px;
    left: 2px;
    transition: transform 0.3s;
  }
  .plans-toggle-switch.on::after { transform: translateX(24px); }
  .plans-save-badge {
    background: rgba(34,197,94,0.2);
    color: #22c55e;
    font-size: 12px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 100px;
    border: 1px solid rgba(34,197,94,0.3);
  }

  .plans-grid {
    max-width: 1200px;
    margin: -40px auto 0;
    padding: 0 24px 80px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 24px;
    position: relative;
    z-index: 1;
  }

  .plan-card {
    background: #fff;
    border-radius: 16px;
    border: 2px solid #e2e8f0;
    padding: 32px;
    position: relative;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
  }
  .plan-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0,0,0,0.08);
  }
  .plan-card.featured {
    border-color: #2563eb;
    box-shadow: 0 8px 32px rgba(37,99,235,0.12);
  }
  .plan-popular {
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background: #2563eb;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 16px;
    border-radius: 100px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .plan-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    margin-bottom: 16px;
  }

  .plan-name {
    font-size: 20px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 6px;
  }
  .plan-desc {
    font-size: 14px;
    color: #64748b;
    margin: 0 0 20px;
    line-height: 1.5;
  }

  .plan-price {
    margin-bottom: 24px;
  }
  .plan-price-amount {
    font-size: 40px;
    font-weight: 900;
    color: #0f172a;
    letter-spacing: -0.02em;
    line-height: 1;
  }
  .plan-price-currency {
    font-size: 20px;
    font-weight: 700;
    vertical-align: top;
    margin-right: 2px;
    color: #64748b;
  }
  .plan-price-period {
    font-size: 14px;
    color: #94a3b8;
    font-weight: 500;
  }
  .plan-price-annual {
    font-size: 13px;
    color: #22c55e;
    font-weight: 600;
    margin-top: 4px;
  }

  .plan-divider {
    height: 1px;
    background: #f1f5f9;
    margin: 0 -32px 20px;
  }

  .plan-limits {
    margin-bottom: 20px;
  }
  .plan-limit {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 0;
    font-size: 13px;
    color: #475569;
  }
  .plan-limit-icon {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #f0fdf4;
    color: #22c55e;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .plan-limit-icon svg { width: 12px; height: 12px; }

  .plan-features-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin: 0 0 12px;
  }
  .plan-features {
    list-style: none;
    padding: 0;
    margin: 0 0 24px;
    flex: 1;
  }
  .plan-features li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 6px 0;
    font-size: 13.5px;
    color: #334155;
    line-height: 1.4;
  }
  .plan-features li svg {
    flex-shrink: 0;
    margin-top: 2px;
  }

  .plan-cta {
    display: block;
    width: 100%;
    padding: 12px 24px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    text-decoration: none;
    transition: all 0.2s;
    cursor: pointer;
    border: none;
    font-family: inherit;
  }
  .plan-cta-primary {
    background: #2563eb;
    color: #fff;
  }
  .plan-cta-primary:hover { background: #1d4ed8; }
  .plan-cta-outline {
    background: transparent;
    color: #2563eb;
    border: 2px solid #e2e8f0;
  }
  .plan-cta-outline:hover { border-color: #2563eb; background: #eff6ff; }

  .plans-faq {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 24px 80px;
  }
  .plans-faq h2 {
    text-align: center;
    font-size: 28px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 32px;
  }
  .plans-faq-item {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .plans-faq-q {
    padding: 16px 20px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: #0f172a;
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    font-family: inherit;
  }
  .plans-faq-q:hover { background: #fafbfc; }
  .plans-faq-a { padding: 0 20px 16px; font-size: 14px; color: #475569; line-height: 1.6; }

  .plans-cta {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 24px 80px;
    text-align: center;
  }
  .plans-cta-card {
    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%);
    border-radius: 20px;
    padding: 48px;
    color: #fff;
  }
  .plans-cta-card h2 { margin: 0 0 10px; font-size: 26px; font-weight: 800; }
  .plans-cta-card p { margin: 0 0 24px; font-size: 15px; color: rgba(255,255,255,0.7); }
  .plans-cta-buttons { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }
  .plans-cta-btn {
    display: inline-flex; align-items: center; gap: 8px;
    padding: 12px 28px; border-radius: 10px; font-size: 14px;
    font-weight: 700; text-decoration: none; transition: all 0.2s;
  }
  .plans-cta-btn-primary { background: #2563eb; color: #fff; }
  .plans-cta-btn-primary:hover { background: #1d4ed8; }
  .plans-cta-btn-secondary {
    background: rgba(255,255,255,0.1); color: #fff;
    border: 1px solid rgba(255,255,255,0.2);
  }
  .plans-cta-btn-secondary:hover { background: rgba(255,255,255,0.15); }

  @media (max-width: 768px) {
    .plans-hero { padding: 60px 20px 40px; }
    .plans-hero h1 { font-size: 32px; }
    .plans-grid { grid-template-columns: 1fr; padding: 0 16px 60px; gap: 16px; }
    .plan-card { padding: 24px; }
  }
`;

const PLAN_ICONS = {
  starter: { emoji: '🚀', bg: '#eff6ff', color: '#2563eb' },
  professional: { emoji: '⭐', bg: '#fef3c7', color: '#d97706' },
  business: { emoji: '💼', bg: '#f0fdf4', color: '#059669' },
  enterprise: { emoji: '🏢', bg: '#faf5ff', color: '#7c3aed' },
  default: { emoji: '📦', bg: '#f1f5f9', color: '#64748b' },
};

const FAQ_DATA = [
  { q: 'Can I change my plan later?', a: 'Yes, you can upgrade or downgrade your plan at any time from your account settings. Upgrades take effect immediately with prorated billing, and downgrades take effect at the end of your current billing period.' },
  { q: 'Is there a free trial?', a: 'Yes! We offer a 14-day free trial on all plans. No credit card required. You can explore all features of your chosen plan during the trial period.' },
  { q: 'What payment methods do you accept?', a: 'We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers for annual plans. All payments are processed securely.' },
  { q: 'What happens when I reach my plan limits?', a: 'We\'ll notify you when you\'re approaching your plan limits. You can either upgrade to a higher plan or wait until the next billing cycle when your limits reset.' },
  { q: 'Can I cancel my subscription?', a: 'Yes, you can cancel at any time. Your access continues until the end of your current billing period. Annual subscribers may request a prorated refund within 14 days of renewal.' },
  { q: 'Do you offer discounts for nonprofits?', a: 'Yes, we offer special pricing for registered nonprofits and educational institutions. Contact our sales team for more details.' },
];

function PlanCard({ plan, annual }) {
  const icon = PLAN_ICONS[plan.slug] || PLAN_ICONS.default;
  const rawPrice = annual ? (plan.price_yearly || plan.price_monthly * 10) : plan.price_monthly;
  const rawMonthly = annual ? (plan.price_yearly / 12) : plan.price_monthly;
  const fmt = (v) => { const n = parseFloat(v) || 0; return n % 1 === 0 ? n.toLocaleString('en-US') : n.toFixed(2); };
  const price = fmt(rawPrice);
  const monthlyEquiv = fmt(rawMonthly);
  const savings = annual && plan.price_monthly > 0 ? Math.round((1 - (plan.price_yearly / (plan.price_monthly * 12))) * 100) : 0;
  const features = plan.features ? (typeof plan.features === 'string' ? JSON.parse(plan.features) : plan.features) : [];

  return (
    <div className={`plan-card ${plan.slug === 'professional' ? 'featured' : ''}`}>
      {plan.slug === 'professional' && <div className="plan-popular">Most Popular</div>}

      <div className="plan-icon" style={{ background: icon.bg, color: icon.color }}>
        {icon.emoji}
      </div>
      <div className="plan-name">{plan.name}</div>
      <div className="plan-desc">{plan.description || 'Everything you need to get started'}</div>

      <div className="plan-price">
        <span className="plan-price-currency">$</span>
        <span className="plan-price-amount">{monthlyEquiv}</span>
        <span className="plan-price-period">/month</span>
        {annual && savings > 0 && (
          <div className="plan-price-annual">Billed ${price}/year — Save {savings}%</div>
        )}
      </div>

      <div className="plan-divider" />

      <div className="plan-limits">
        {plan.max_users && (
          <div className="plan-limit">
            <div className="plan-limit-icon">
              <svg fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg>
            </div>
            Up to {plan.max_users} users
          </div>
        )}
        {plan.max_invoices_month && (
          <div className="plan-limit">
            <div className="plan-limit-icon">
              <svg fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg>
            </div>
            {plan.max_invoices_month.toLocaleString()} invoices/month
          </div>
        )}
        {plan.max_storage_mb && (
          <div className="plan-limit">
            <div className="plan-limit-icon">
              <svg fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg>
            </div>
            {plan.max_storage_mb >= 1024 ? `${plan.max_storage_mb / 1024} GB` : `${plan.max_storage_mb} MB`} storage
          </div>
        )}
      </div>

      <div className="plan-features-title">Included features</div>
      <ul className="plan-features">
        {features.map((f, i) => (
          <li key={i}>
            <svg width="16" height="16" fill="none" stroke="#22c55e" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg>
            {f}
          </li>
        ))}
        {features.length === 0 && (
          <>
            <li><svg width="16" height="16" fill="none" stroke="#22c55e" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg>Invoicing &amp; Estimates</li>
            <li><svg width="16" height="16" fill="none" stroke="#22c55e" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg>Customer &amp; Vendor Management</li>
            <li><svg width="16" height="16" fill="none" stroke="#22c55e" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg>Financial Reports</li>
            <li><svg width="16" height="16" fill="none" stroke="#22c55e" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg>Email Support</li>
          </>
        )}
      </ul>

      <Link
        to={`/register?plan=${plan.id}`}
        className={`plan-cta ${plan.slug === 'professional' ? 'plan-cta-primary' : 'plan-cta-outline'}`}
      >
        Start Free Trial
      </Link>
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="plans-faq-item">
      <button className="plans-faq-q" onClick={() => setOpen(!open)}>
        {q}
        <svg width="18" height="18" fill="none" stroke={open ? '#2563eb' : '#94a3b8'} strokeWidth="2" viewBox="0 0 24 24" style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', flexShrink: 0 }}><path d="M6 9l6 6 6-6" /></svg>
      </button>
      {open && <div className="plans-faq-a">{a}</div>}
    </div>
  );
}

export default function PlansPage() {
  const [plans, setPlans] = useState([]);
  const [annual, setAnnual] = useState(true);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const API_URL = process.env.REACT_APP_API_URL || '/api';
    fetch(`${API_URL}/subscriptions/plans/public`)
      .then(r => r.json())
      .then(data => { setPlans(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const dayOfWeek = new Date().getDay();

  return (
    <div className="plans-page" style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <style>{STYLES}</style>

      {/* Nav */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', height: 56, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 10, background: '#0f172a', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 900 }}>LP</div>
            <span style={{ fontSize: 17, fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em' }}>LedgerPro</span>
          </Link>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <Link to="/login" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 500, fontSize: 13, padding: '6px 12px', borderRadius: 6 }}>Sign In</Link>
            <Link to="/register" style={{ color: '#fff', textDecoration: 'none', fontWeight: 600, fontSize: 13, padding: '8px 16px', borderRadius: 8, background: '#2563eb' }}>Get Started</Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <div className="plans-hero" style={{ marginTop: 56 }}>
        <div className="plans-hero-badge">
          <span>💎</span>
          <span>Simple, transparent pricing</span>
        </div>
        <h1>Choose Your Plan</h1>
        <p className="plans-hero-sub">
          Start your 14-day free trial today. No credit card required. Upgrade or downgrade anytime.
        </p>
        <div className="plans-toggle">
          <span className={`plans-toggle-label ${!annual ? 'active' : ''}`}>Monthly</span>
          <div className={`plans-toggle-switch ${annual ? 'on' : ''}`} onClick={() => setAnnual(!annual)} />
          <span className={`plans-toggle-label ${annual ? 'active' : ''}`}>Annual</span>
          {annual && <span className="plans-save-badge">Save up to 20%</span>}
        </div>
      </div>

      {/* Plans Grid */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '80px 24px' }}>
          <div style={{ width: 40, height: 40, border: '3px solid #e2e8f0', borderTopColor: '#2563eb', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <p style={{ color: '#94a3b8', fontSize: 14, margin: 0 }}>Loading plans...</p>
        </div>
      ) : plans.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '80px 24px' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📦</div>
          <h2 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', margin: '0 0 8px' }}>Plans Coming Soon</h2>
          <p style={{ color: '#64748b', fontSize: 15 }}>Our subscription plans are being set up. Please check back soon or contact sales.</p>
        </div>
      ) : (
        <div className="plans-grid">
          {plans.map(plan => (
            <PlanCard key={plan.id} plan={plan} annual={annual} />
          ))}
        </div>
      )}

      {/* FAQ */}
      <div className="plans-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQ_DATA.map((faq, i) => (
          <FaqItem key={i} q={faq.q} a={faq.a} />
        ))}
      </div>

      {/* Bottom CTA */}
      <div className="plans-cta">
        <div className="plans-cta-card">
          <h2>Ready to Get Started?</h2>
          <p>Join thousands of businesses using LedgerPro. Start your free trial today — no credit card required.</p>
          <div className="plans-cta-buttons">
            <Link to="/register" className="plans-cta-btn plans-cta-btn-primary">
              Start Free Trial
              <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
            </Link>
            <Link to="/login" className="plans-cta-btn plans-cta-btn-secondary">
              Sign In to Account
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ background: '#0f172a', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '32px 24px', textAlign: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 12 }}>
            <div style={{ width: 28, height: 28, borderRadius: 7, background: 'rgba(255,255,255,0.1)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 900 }}>LP</div>
            <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>LedgerPro</span>
          </div>
          <p style={{ margin: 0, fontSize: 12, color: '#475569' }}>&copy; {new Date().getFullYear()} LedgerPro Accounting System by Rahkar Hoshmand. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
